// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__34yXL","inner":"Form_inner__wexZ1","range":"Form_range__161h8","name":"Form_name__3Rzt6","actions":"Form_actions__G-Yc1"};